import { __assign, __awaiter, __generator, __read } from "tslib";
import React, { useEffect } from 'react';
import { SkeletonNormalList, Skeleton } from '@hose/eui';
import { ProfileCard } from './profile-card';
import { getStaffFieldConfig, getStaffInfoById } from './apis';
import styles from './profile-card.module.less';
export var FledgedProfileCard = function (_a) {
    var staffId = _a.staffId;
    var _b = __read(React.useState({
        dataSource: {
            template: {},
            value: {},
            order: []
        },
        selectedFields: []
    }), 2), dataSource = _b[0], setDataSource = _b[1];
    var _c = __read(React.useState(true), 2), isLoading = _c[0], setLoading = _c[1];
    var _d = __read(React.useState(false), 2), isError = _d[0], setError = _d[1];
    useEffect(function () {
        var initData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, _dataSource, resp, error_1;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        setLoading(true);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, 4, 5]);
                        return [4, Promise.all([
                                getStaffInfoById(staffId),
                                getStaffFieldConfig()
                            ])];
                    case 2:
                        _a = __read.apply(void 0, [_c.sent(), 2]), _dataSource = _a[0], resp = _a[1];
                        if (_dataSource.value && resp.value) {
                            setDataSource({
                                dataSource: _dataSource.value,
                                selectedFields: (_b = resp === null || resp === void 0 ? void 0 : resp.value.staffFieldsConfig) === null || _b === void 0 ? void 0 : _b.fieldsName
                            });
                        }
                        else {
                            setError(true);
                        }
                        return [3, 5];
                    case 3:
                        error_1 = _c.sent();
                        setError(true);
                        return [3, 5];
                    case 4:
                        setLoading(false);
                        return [7];
                    case 5: return [2];
                }
            });
        }); };
        initData();
    }, []);
    var loadingEls = React.createElement("div", { className: styles.loading },
        React.createElement("div", { className: styles.title },
            React.createElement(Skeleton, { type: "avatar", className: styles.avatar }),
            React.createElement(Skeleton, { type: "title" })),
        React.createElement(SkeletonNormalList, { showText: true, lineCount: 7 }));
    return isLoading ? (loadingEls) : isError ? (React.createElement("div", { className: styles.error }, i18n.get('数据加载失败，请重新'))) : (React.createElement(ProfileCard, __assign({}, dataSource)));
};
